export default __webpack_public_path__ + "media/images/android-icon-54e0c708.svg";